import React, { useState } from "react";
import { Collapse, Form } from "react-bootstrap";
import { SlCalender } from "react-icons/sl";
import CalendarModalData from "./CalenderModalData";

const FormDateCalender = ({ field, handleDateChange, dateValue, StudyMode, studyPermission, printable, editField }) => {
  const today = new Date();
  const [showCalendar, setShowCalendar] = useState(false);

  const days = Array.from({ length: 31 }, (_, index) => {
    const day = index + 1;
    return day.toString().padStart(2, '0');
  });

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 150 }, (_, index) => (currentYear - index).toString());

  const textMonths = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
  ];
  const numberMonths = Array.from({ length: 12 }, (_, index) => {
    const numberMonth = index + 1;
    return numberMonth.toString().padStart(2, '0');
  });

  function isMMMFormat(dateStr) {
    let regexMMM = /\b(MMM)\b/i;
    const parts = dateStr.split('_');
    if (dateStr === "DD_MMM_YYYY" || dateStr === "YYYY_MMM_DD") {
      return /^[A-Za-z]{3}$/.test(parts[1]);
    } else if (regexMMM.test(dateStr)) {
      return true;
    } else {
      return false;
    }
  }

  function isFirstPartYYYY(dateStr) {
    return dateStr.startsWith("YYYY");
  }

  let currentDate = new Date();
  const selectedMonthData = (month) => {
    if (!month || month === "UNK") {
      return currentDate.getMonth();
    } else {
      if (textMonths.includes(month)) {
        return Number(textMonths.indexOf(month))
      } else {
        return Number(month) - 1
      }
    }
  }

  const selectedDayData = (day) => {
    if (!day || day === "UNK") {
      return currentDate.getDate();
    } else {
      return Number(day)
    }
  }

  const selectedYearData = (year) => {
    if (!year || year === "UNK") {
      return currentDate.getFullYear();
    } else {
      return Number(year)
    }
  }

  const dayValid = today.getDate();
  const monthValid = today.getMonth() + 1;
  const yearValid = today.getFullYear();

  return (
    <div className="position-relative">
      <div className="d-flex gap-2" style={{ width: `${Number(field?.fieldWidthSize || 100)}%` }} >
        {isFirstPartYYYY(field?.dateFormat) ?
          <Form.Group>
            <Form.Label className="mb-1 fw-bold">Year</Form.Label>
            <Form.Select
              disabled={printable || (editField?.includes(field.id) ? false : (field?.fieldDerivation === "assigned" || field?.fieldDerivation === "derived")) || StudyMode?.startsWith("SDV") || studyPermission?.qcReadOnly || studyPermission?.liveReadOnly || dateValue?.status === "freezed"}
              onChange={(e) => handleDateChange(field?.id, "year", e.target.value)}
              style={{ fontSize: 12 }}
              className="br3"
            >
              <option selected={(dateValue?.year || "") === ""} value={""}>Select Year</option>
              <option selected={dateValue?.year === "UNK"} value={"UNK"}>UNK</option>
              {years.map((yearData, i) => (
                <option
                  hidden={((dayValid < Number(dateValue?.day)) && (monthValid < (textMonths.indexOf(dateValue?.month) + 1))) ? Number(yearData) === yearValid : (monthValid < (textMonths.indexOf(dateValue?.month) + 1)) ? Number(yearData) === yearValid : false}
                  selected={dateValue?.year === yearData} key={i} value={yearData}>
                  {yearData}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
          :
          <Form.Group>
            <Form.Label className="mb-1 fw-bold">Day</Form.Label>
            <Form.Select
              disabled={printable || (editField?.includes(field.id) ? false : (field?.fieldDerivation === "assigned" || field?.fieldDerivation === "derived")) || StudyMode?.startsWith("SDV") || studyPermission?.qcReadOnly || studyPermission?.liveReadOnly || dateValue?.status === "freezed"}
              onChange={(e) => handleDateChange(field?.id, "day", e.target.value)}
              style={{ fontSize: 12 }}
              className="br3"
            >
              <option selected={(dateValue?.day || "") === ""} value={""}>Select Day</option>
              <option selected={dateValue?.day === "UNK"} value={"UNK"}>UNK</option>
              {days.map((dayData, i) => (
                <option
                  hidden={(Number(dateValue?.year) === yearValid) ? ((monthValid === textMonths.indexOf(dateValue?.month) + 1) ? (dayValid <= i) : false) : false}
                  selected={dayData === dateValue?.day} key={i} value={dayData}>
                  {dayData}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        }
        <Form.Group>
          <Form.Label className="mb-1 fw-bold">Month</Form.Label>
          <Form.Select
            disabled={printable || (editField?.includes(field.id) ? false : (field?.fieldDerivation === "assigned" || field?.fieldDerivation === "derived")) || StudyMode?.startsWith("SDV") || studyPermission?.qcReadOnly || studyPermission?.liveReadOnly || dateValue?.status === "freezed"}
            onChange={(e) => handleDateChange(field?.id, "month", e.target.value)}
            style={{ fontSize: 12 }}
            className="br3"
          >
            <option selected={(dateValue?.month || "") === ""} value={""}>Select Month</option>
            <option selected={dateValue?.month === "UNK"} value={"UNK"}>UNK</option>
            {(isMMMFormat(field?.dateFormat) ? textMonths : numberMonths)?.map((monthData, i) => (
              <option
                key={i}
                selected={monthData === dateValue?.month}
                value={monthData}
                hidden={(Number(dateValue?.year) === yearValid) ? (dayValid < Number(dateValue?.day) ? (monthValid - 1 <= i) : (monthValid <= i)) : false}
              >
                {monthData}
              </option>
            ))}
          </Form.Select>
        </Form.Group>
        {isFirstPartYYYY(field?.dateFormat) ?
          <Form.Group>
            <Form.Label className="mb-1 fw-bold">Day</Form.Label>
            <Form.Select
              disabled={printable || (editField?.includes(field.id) ? false : (field?.fieldDerivation === "assigned" || field?.fieldDerivation === "derived")) || StudyMode?.startsWith("SDV") || studyPermission?.qcReadOnly || studyPermission?.liveReadOnly || dateValue?.status === "freezed"}
              onChange={(e) => handleDateChange(field?.id, "day", e.target.value)}
              style={{ fontSize: 12 }}
              className="br3"
            >
              <option selected={(dateValue?.day || "") === ""} value={""}>Select Day</option>
              <option selected={dateValue?.day === "UNK"} value={"UNK"}>UNK</option>
              {days.map((dayData, i) => (
                <option
                  hidden={(Number(dateValue?.year) === yearValid) ? ((monthValid === textMonths.indexOf(dateValue?.month) + 1) ? (dayValid <= i) : false) : false}
                  selected={dayData === dateValue?.day} key={i} value={dayData}
                >
                  {dayData}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
          :
          <Form.Group>
            <Form.Label className="mb-1 fw-bold">Year</Form.Label>
            <Form.Select
              disabled={printable || (editField?.includes(field.id) ? false : (field?.fieldDerivation === "assigned" || field?.fieldDerivation === "derived")) || StudyMode?.startsWith("SDV") || studyPermission?.qcReadOnly || studyPermission?.liveReadOnly || dateValue?.status === "freezed"}
              onChange={(e) => handleDateChange(field?.id, "year", e.target.value)}
              style={{ fontSize: 12 }}
              className="br3"
            >
              <option selected={(dateValue?.year || "") === ""} value={""}>Select Year</option>
              <option selected={dateValue?.year === "UNK"} value={"UNK"}>UNK</option>
              {years.map((yearData, i) => (
                <option
                  hidden={((dayValid < Number(dateValue?.day)) && (monthValid < (textMonths.indexOf(dateValue?.month) + 1))) ? Number(yearData) === yearValid : (monthValid < (textMonths.indexOf(dateValue?.month) + 1)) ? Number(yearData) === yearValid : false}
                  selected={yearData === dateValue?.year} key={i} value={yearData}>
                  {yearData}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        }

        {printable || !(StudyMode?.startsWith("SDV") || studyPermission?.qcReadOnly || studyPermission?.liveReadOnly || dateValue?.status === "freezed" || (editField?.includes(field.id) ? false : (field?.fieldDerivation === "assigned" || field?.fieldDerivation === "derived"))) &&
          <Form.Group>
            <Form.Label className="mb-2 fw-bold">Date</Form.Label>
            <div className="hstack gap-1 position-relative">
              <SlCalender
                disabled={printable || (editField?.includes(field.id) ? false : (field?.fieldDerivation === "assigned" || field?.fieldDerivation === "derived")) || StudyMode?.startsWith("SDV") || studyPermission?.qcReadOnly || studyPermission?.liveReadOnly || dateValue?.status === "freezed"}
                onClick={() => setShowCalendar(!showCalendar)}
                className="CP"
                title="Open Calender"
              />
              <Collapse in={showCalendar === true}>
                <div className="position-absolute z-1" style={{ top: 20 }}>
                  <CalendarModalData
                    selectedDate={new Date(selectedYearData(dateValue?.year), selectedMonthData(dateValue?.month), selectedDayData(dateValue?.day))}
                    onClose={() => setShowCalendar(false)}
                    onSelectDate={(date) => {
                      const updatedDate = {
                        day: date.getDate().toString().padStart(2, '0'),
                        month: isMMMFormat(field?.dateFormat) ? textMonths[Number(date.getMonth())] : (date.getMonth() + 1).toString().padStart(2, '0'),
                        year: date.getFullYear().toString()
                      };
                      handleDateChange(field?.id, updatedDate);
                      setShowCalendar(false);
                    }}
                    day={dateValue?.day === "UNK" ? "UNK" : Number(dateValue?.day)}
                    month={dateValue?.month === "UNK" ? "UNK" : (isMMMFormat(field?.dateFormat) ? dateValue?.month : textMonths[Number(dateValue?.month) - 1])}
                    year={dateValue?.year === "UNK" ? "UNK" : Number(dateValue?.year)}
                  />
                </div>
              </Collapse>
              <div
                style={{ fontSize: 12 }}
                title="Set Today"
                onClick={() => {
                  const updatedDate = {
                    day: today.getDate().toString().padStart(2, '0'),
                    month: isMMMFormat(field?.dateFormat) ? textMonths[Number(today.getMonth())] : (today.getMonth() + 1).toString().padStart(2, '0'),
                    year: today.getFullYear().toString()
                  };
                  handleDateChange(field?.id, updatedDate);
                }}
                className="CP"
              >
                Today
              </div>
            </div>
          </Form.Group>
        }
      </div>
    </div>
  );
};

export default FormDateCalender;
